export class MapsUtil {
    /**
     * Abre Google Maps con las coordenadas especificadas
     * Funciona en dispositivos móviles y de escritorio
     * @param lat - Latitud (opcional)
     * @param lon - Longitud (opcional)
     */
    static openGoogleMaps(lat?: number, lon?: number): void {
        if (!lat || !lon) {
            console.warn('MapsUtil: Coordenadas inválidas para abrir Google Maps');
            return;
        }

        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        if (isMobile) {
            const googleMapsAppURL = `https://maps.google.com/maps?q=${lat},${lon}`;
            
            const mapsLink = document.createElement('a');
            mapsLink.href = googleMapsAppURL;
            mapsLink.target = '_blank';
            mapsLink.rel = 'noopener noreferrer';
            
            document.body.appendChild(mapsLink);
            mapsLink.click();
            document.body.removeChild(mapsLink);
        } else {
            const googleMapsURL = `https://www.google.com/maps/place/${lat},${lon}`;
            window.open(googleMapsURL, '_blank', 'noopener,noreferrer');
        }
    }

    /**
     * Genera la URL de Google Maps para usar en enlaces HTML
     * @param lat - Latitud (opcional)
     * @param lon - Longitud (opcional)
     * @returns URL de Google Maps o string vacío si las coordenadas son inválidas
     */
    static getGoogleMapsURL(lat?: number, lon?: number): string {
        if (!lat || !lon) {
            return '#';
        }

        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        if (isMobile) {
            return `https://maps.google.com/maps?q=${lat},${lon}`;
        } else {
            return `https://www.google.com/maps/place/${lat},${lon}`;
        }
    }
}
